import type { PageviewNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within, SubFilters } from '../condition-parts';

type PageviewConditionProps = { node: PageviewNode };

export function PageviewCondition({ node }: PageviewConditionProps) {
  const prefix = node.inverse ? 'Has not' : 'Has';
  return (
    <ConditionCard node={node}>
      {prefix} viewed a page
      {node.url != null ? (
        <>
          {' '}
          with the URL <Bold>{node.url}</Bold>
        </>
      ) : null}
      <Times times={node.times} />
      <Within within={node.within} />
      <SubFilters filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionCard>
  );
}
